import PropTypes from "prop-types";
import { isNil } from "ramda";
import { Grid, Button, Container } from "@mui/material";
import { NavLink } from "react-router-dom";

import CategoryPills from "components/CategoryPills";
import Placeholder from "components/Placeholder";
import { appRoutes } from "routes";

import { Root, StyledTitle } from "./styles";

const FeaturedCategories = ({ items, loading }) => {
  const noItems = loading || isNil(items);

  const renderTitle = () => {
    if (noItems)
      return (
        <StyledTitle variant="h2" align="center">
          <Placeholder variant="text" />
        </StyledTitle>
      );
    return (
      <StyledTitle variant="h2" align="center">
        Featured Categories
      </StyledTitle>
    );
  };

  return (
    <Root>
      <Container>
        {renderTitle()}
        <CategoryPills items={items} loading={loading} />
        <Grid container direction="row" justifyContent="center" alignItems="center">
          <Grid item>
            <Button
              id="home-featured-view-more"
              component={NavLink}
              variant="outlined"
              color="primary"
              to={appRoutes.categoriesPath()}
            >
              View more
            </Button>
          </Grid>
        </Grid>
      </Container>
    </Root>
  );
};

FeaturedCategories.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      type: PropTypes.string,
      attributes: PropTypes.shape({}),
    }).isRequired,
  ),
  loading: PropTypes.bool,
};

export default FeaturedCategories;
